import { onBeforeUnmount, onMounted, type Ref } from 'vue';

/**
 * Closes `open` on a pointerdown anywhere outside all of `excludeSelectors`
 * (e.g. the panel itself and its own toggle button, so the toggle isn't
 * double-handled). Shared by AnnotationPane, GameAreaSettingsPane, and
 * MainNav's mobile menu.
 */
export function useOutsidePointerDismiss(open: Ref<boolean>, excludeSelectors: string[]) {
  const handlePointerDown = (e: PointerEvent) => {
    if (!open.value) return;
    const target = e.target as HTMLElement;
    if (excludeSelectors.some((selector) => target.closest(selector))) return;
    open.value = false;
  };

  onMounted(() => document.addEventListener('pointerdown', handlePointerDown));
  onBeforeUnmount(() => document.removeEventListener('pointerdown', handlePointerDown));
}
